var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "layout" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _c("div", { staticClass: "table-responsive" }, [
            _c("table", [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.items, function(item, index) {
                    return _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.idItem === "" || _vm.idItem === item.id_item,
                            expression:
                              "idItem === '' || idItem === item.id_item"
                          }
                        ],
                        key: index
                      },
                      [
                        _c("td", [_vm._v(_vm._s(item.id_item))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("input-field", {
                              attrs: {
                                id: "serie" + index,
                                placeholder: "Escriba la serie..."
                              },
                              model: {
                                value: item.serie,
                                callback: function($$v) {
                                  _vm.$set(item, "serie", $$v)
                                },
                                expression: "item.serie"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(item.descripcion_item))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(item.cantidad))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("input-field", {
                              attrs: {
                                id: "item" + index,
                                placeholder: "##.##",
                                vMoney: "",
                                format: _vm.decimal
                              },
                              on: {
                                input: function($event) {
                                  return _vm.validarCantidadSeleccionada(index)
                                }
                              },
                              model: {
                                value: item.cantidad_seleccionada,
                                callback: function($$v) {
                                  _vm.$set(item, "cantidad_seleccionada", $$v)
                                },
                                expression: "item.cantidad_seleccionada"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.items.length === 0,
                          expression: "items.length === 0"
                        }
                      ]
                    },
                    [_vm._m(2)]
                  )
                ],
                2
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-buttons" }, [
        _c(
          "button",
          {
            staticClass: "btn-danger btn--text",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("cancelar")
              }
            }
          },
          [
            _c("i", { staticClass: "fa fa-ban" }),
            _c("span", [_vm._v("Cancelar")])
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-success",
            attrs: { type: "button" },
            on: { click: _vm.aceptar }
          },
          [
            _c("i", { staticClass: "fa fa-check" }),
            _c("span", [_vm._v("Aceptar")])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Ítems del comprobante")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Código")]),
        _vm._v(" "),
        _c("th", [_vm._v("Serie")]),
        _vm._v(" "),
        _c("th", [_vm._v("Descripción")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cantidad disponible")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cantidad seleccionada")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "5" } }, [
      _c("strong", [_vm._v("No se ha encontrado registros.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a5d6f9d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a5d6f9d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/ItemsComprobante.vue
// module id = 450
// module chunks = 0